import { removeDateWords } from './removeDateWords';
import { removeStopWords } from './removeStopWords';
import { TREEMAP_LABEL_STOPWORDS } from '@/config/treemapLabelStopWords';

// 先頭の一文字だけ、大文字化
const capitalizedStopwords = TREEMAP_LABEL_STOPWORDS.map((word) => {
  return word.charAt(0).toUpperCase() + word.slice(1);
});

// 1. ラベルに日付の文言が含まれている場合は、その日付の文言を削除し、削除した状態でラベルは出す
// 2. ラベルが日付の文言のみの場合は、そのラベルごと非表示にする
// 3. StopWordと完全に一致するラベルは、非表示にする
// 4. Solrのclustering結果ラベルがキャピタルケースになるので、stopwordsをキャピタルケースに変換して比較する
export function filterTreemapLabels(labels: string[]): string[] {
  return labels
    .map((label) => removeDateWords(label))
    .map((label) => removeStopWords(label, capitalizedStopwords))
    .filter((label) => label !== '');
}
